import { render, staticRenderFns } from "./TaskTitle.vue?vue&type=template&id=6d809cdc&scoped=true&"
import script from "./TaskTitle.vue?vue&type=script&lang=js&"
export * from "./TaskTitle.vue?vue&type=script&lang=js&"
import style0 from "./TaskTitle.vue?vue&type=style&index=0&id=6d809cdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d809cdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d809cdc')) {
      api.createRecord('6d809cdc', component.options)
    } else {
      api.reload('6d809cdc', component.options)
    }
    module.hot.accept("./TaskTitle.vue?vue&type=template&id=6d809cdc&scoped=true&", function () {
      api.rerender('6d809cdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverableTemplates/TaskTitle.vue"
export default component.exports